<template>
    <sa-page-layout :btnRefreshVisible="true" :btnNewVisible="false" :pathResource="pathResource" @refresh="onRefresh" :linkedit="linkedit">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovo">
                <b-icon icon="plus"> </b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-body">
            <flussi-list-component ref="cmpFlussiList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
            <flussi-modal-edit-component ref="cmpFlussiModalEdit" @afterSave="onAfterSave"></flussi-modal-edit-component>
        </template>
    </sa-page-layout>
</template>
<script>
// import axios from "axios";
// import moment from "moment";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import FlussiListComponent from "../components/FlussiListComponent.vue";
import FlussiModalEditComponent from "../components/FlussiModalEditComponent.vue";
export default {
    components: { SaPageLayout, FlussiListComponent, FlussiModalEditComponent },
    computed: {
        rows() {
            return this.items.length;
        },
    },
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            filter: null,
            id: "-1",
            pathResource: "/flussi",
            linkedit: "/struttura",
            filtro: {},
            filterOn: [],
            fields: [
                {
                    label: "Tipo",
                    key: "tipo",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                {
                    label: "Mese Riferimento",
                    key: "meseRiferimento",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                {
                    label: "Anno Riferimento",
                    key: "annoRiferimento",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            items: [
                { tipo: "FILE H", meseRiferimento: "MARZO", annoRiferimento: "2025" },
                { tipo: "FILE H", meseRiferimento: "APRILE", annoRiferimento: "2025" },
            ],
        };
    },
    mounted: function () {
        let me = this;
        me.loadData();
    },
    methods: {
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        loadData() {
            let me = this;
            me.$refs.cmpFlussiList.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onClickNuovo() {
            let me = this;
            me.$refs.cmpFlussiModalEdit.show();
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
